/**
 * @generated SignedSource<<e1a3e7fdbc91c9ac54de44a82b6d8ac0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Colors = "BLUE" | "GREEN" | "NO_COLOR" | "ORANGE" | "PURPLE" | "RED" | "YELLOW";
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
import { FragmentRefs } from "relay-runtime";
export type MeetingContainerModalNote_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly featureAccess: any;
      readonly hasAccessToAsana: boolean;
      readonly hasAccessToComments: boolean;
      readonly hasAccessToDuedates: boolean;
      readonly hasAccessToEmbeds: boolean;
      readonly hasAccessToHubspot: boolean;
      readonly hasAccessToJiraIntegration: boolean;
      readonly hasAccessToMeetingFeedback: boolean;
      readonly hasAccessToMultipleAssignees: boolean;
      readonly hasAccessToNoteLocking: boolean;
      readonly hasAccessToNotesIntegrationExport: boolean;
      readonly hasAccessToObjectives: boolean;
      readonly hasAccessToPromptHeadings: boolean;
      readonly hasAccessToSalesforce: boolean;
      readonly hasAccessToSharing: boolean;
      readonly hasAccessToVersioning: boolean;
      readonly hasAccessToZapierIntegration: boolean;
    };
    readonly integrations: {
      readonly jira: {
        readonly baseUrl: string;
        readonly clientKey: string;
        readonly id: string;
      } | null;
    };
    readonly loomEnabled: boolean;
    readonly tags: ReadonlyArray<{
      readonly __typename: "Tag";
      readonly color: Colors;
      readonly id: string;
      readonly label: string;
    }>;
  };
  readonly connectedActionItemIntegrations: ReadonlyArray<IntegrationProvider>;
  readonly integrations: {
    readonly asana: {
      readonly isConnected: boolean;
    } | null;
  };
  readonly user: {
    readonly firstName: string;
    readonly id: string;
    readonly isGuest: boolean;
  };
  readonly uxSimplificationEnabled: boolean;
  readonly " $fragmentType": "MeetingContainerModalNote_viewer";
};
export type MeetingContainerModalNote_viewer$key = {
  readonly " $data"?: MeetingContainerModalNote_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingContainerModalNote_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingContainerModalNote_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uxSimplificationEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "loomEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "tags",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToDuedates",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "duedates"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"duedates\")"
            },
            {
              "alias": "hasAccessToVersioning",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "versioning"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"versioning\")"
            },
            {
              "alias": "hasAccessToSharing",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "sharing"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"sharing\")"
            },
            {
              "alias": "hasAccessToJiraIntegration",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "jira_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"jira_integration\")"
            },
            {
              "alias": "hasAccessToComments",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "comments"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"comments\")"
            },
            {
              "alias": "hasAccessToMeetingFeedback",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "meeting_feedback"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"meeting_feedback\")"
            },
            {
              "alias": "hasAccessToNoteLocking",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "note_locking"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"note_locking\")"
            },
            {
              "alias": "hasAccessToZapierIntegration",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "zapier_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"zapier_integration\")"
            },
            {
              "alias": "hasAccessToEmbeds",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "embeds"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"embeds\")"
            },
            {
              "alias": "hasAccessToSalesforce",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "salesforce_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
            },
            {
              "alias": "hasAccessToHubspot",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "hubspot_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"hubspot_integration\")"
            },
            {
              "alias": "hasAccessToAsana",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "asana_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"asana_integration\")"
            },
            {
              "alias": "hasAccessToObjectives",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "objectives"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"objectives\")"
            },
            {
              "alias": "hasAccessToPromptHeadings",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "prompt_headings"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"prompt_headings\")"
            },
            {
              "alias": "hasAccessToNotesIntegrationExport",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "notes_integration_export"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"notes_integration_export\")"
            },
            {
              "alias": "hasAccessToMultipleAssignees",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "multiple_assignees"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"multiple_assignees\")"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "featureAccess",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountIntegrations",
          "kind": "LinkedField",
          "name": "integrations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "JiraAccountNode",
              "kind": "LinkedField",
              "name": "jira",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "clientKey",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "baseUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "connectedActionItemIntegrations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AsanaUserNode",
          "kind": "LinkedField",
          "name": "asana",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isConnected",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "fc453df6f0b864943080dd5c1a8016b2";

export default node;
